import Vue from "vue";
import JsonEditorVue from 'json-editor-vue'

Vue.use(JsonEditorVue);
